module.exports = __webpack_public_path__ + "img/download.112cbca1.svg";